export default {
  data () {
    return {
      jumpSchools: [
        {
          id: '49',
          name: '浙江工业大学'
        },
        {
          id: '70',
          name: '浙江工业大学之江学院'
        },
        {
          id: '66',
          name: '浙江师范大学'
        },
        {
          id: '99',
          name: '温州商学院'
        },
        {
          id: '110',
          name: '宁波大学科学技术学院'
        },
        {
          id: '40', // 浙江大学宁波理工学院-商学院
          name: '46'
        },
        {
          id: '34', // 浙江大学宁波理工学院-计算机与数据工程学院
          name: '47'
        },
        {
          id: '35', // 浙江大学宁波理工学院-传媒与设计学院
          name: '48'
        },
        {
          id: '36', // 浙江大学宁波理工学院-外国语学院
          name: '49'
        },
        {
          id: '42', // 浙江大学宁波理工学院-信息科学与工程学院
          name: '50'
        },
        {
          id: '37', // 浙江大学宁波理工学院-生物与化学工程学院
          name: '51'
        },
        {
          id: '38', // 浙江大学宁波理工学院-机电与能源工程学院
          name: '52'
        },
        {
          id: '39', // 浙江大学宁波理工学院-土木建筑工程学院
          name: '53'
        },
        {
          id: '43', // 浙江大学宁波理工学院-法律与政治学院
          name: '54'
        }
      ]
    }
  },
  methods: {
    goToMiniPage (collegeID) {
      // 隐藏跳转小程序咨询
      // const isJump = this.jumpSchools.map(({id}) => {
      //   return Number(id) === Number(collegeID)
      // }).filter(v => !!v).reduce((a, b) => a || b, false)
      // if (isJump) {
      //   this.$router.push(`../miniProgram`)
      // } else {
      //   this.$router.push(`../experts`)
      // }
      this.$router.push(`../experts`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/goToMiniPage.js